import * as Styled from './ContentCard.styles';
import { Divider, Paper } from '@mui/material';
import React from 'react';
/**
 * Content card
 */
export const ContentCard = ({ children, header, footer, className, dataCy, applyBodyPadding, applyHeaderDivider, applyFooterDivider, applyMarginBottom, fullHeight, minHeight, }) => {
    return (React.createElement(Styled.Wrapper, { className: className, "data-cy": dataCy, "$fullHeight": fullHeight, "$applyMarginBottom": applyMarginBottom },
        React.createElement(Paper, { square: true },
            header && React.createElement("div", null, header),
            header && applyHeaderDivider ? (React.createElement(Divider, { className: "ContentCard--header--divider" })) : undefined,
            React.createElement(Styled.BodyWrapper, { "$minHeight": minHeight },
                React.createElement(Styled.Body, { className: "ContentCard--body", applyBodyPadding: applyBodyPadding }, children),
                footer && applyFooterDivider ? (React.createElement(Divider, { className: "ContentCard--footer--divider" })) : undefined,
                footer && React.createElement("div", null, footer)))));
};
ContentCard.defaultProps = {
    applyBodyPadding: true,
};
export default React.memo(ContentCard);
